import { NavBarHeaderItem } from '../types/NavBarItem';

import GlossaryIcon from '../../assets/icons/Sidebar/glossary-icon.svg?react';
import UserGuideIcon from '../../assets/icons/Sidebar/userInfo-icon.svg?react';
import FeedbackIcon from '../../assets/icons/Header/feedback.svg?react';
import DownloadIcon from '../../assets/icons/General/download.svg?react';
import LogoutIcon from '../../assets/icons/Header/logout.svg?react';
import DimensionsIcon from '../../assets/icons/dimensions.svg?react';
import profileIcon from '../../assets/icons/Header/user-profile.svg';

export const HeaderItemKey = {
  GLOSSARY: 'glossary',
  VIEW_USER_GUIDE: 'viewUserGuide',
  DOWNLOAD_REPORTS: 'downloadReports',
  SUBMIT_FEEDBACK: 'submitFeedback',
  MEMBER_MANAGEMENT: 'memberManagement',
  DIMENSION_PREVIOUS_VERSION: 'dimensionPreviousVersion',
  SIGNOUT: 'signOut',
};

export const SidebarItemItemKey = {
  ORG_DIM: 'dimensions',
  COACHING_UTILISATION: 'coaching-utilisation',
  CLINICAL_UTILISATION: 'clinical-utilisation',
  EAP_UTILISATION: 'eap-utilisation',
  HOLISTIC_UTILISATION: 'holistic-utilisation',
  CONTENT_UTILISATION: 'content-utilisation',
  ADOPTION: 'adoption',
  MOOD_CHECKIN: 'mood-checkin',
};

export const NavBarHeaderItems: NavBarHeaderItem[] = [
  {
    key: HeaderItemKey.DOWNLOAD_REPORTS,
    label: 'Download reports',
    icons: DownloadIcon,
    showDesktop: false,
  },
  {
    key: HeaderItemKey.GLOSSARY,
    label: 'Glossary',
    icons: GlossaryIcon,
    link: `${import.meta.env.VITE_IMAGE_BASE_URL}uploads/dimensions/Insights+dashboard+glossary.pdf `,
  },
  {
    key: HeaderItemKey.VIEW_USER_GUIDE,
    label: 'View user guide',
    icons: UserGuideIcon,
    link: `${import.meta.env.VITE_IMAGE_BASE_URL}uploads/dimensions/Insights+Dashboard+User+Guide.pdf`,
  },
  {
    key: HeaderItemKey.SUBMIT_FEEDBACK,
    label: 'Submit feedback',
    icons: FeedbackIcon,
  },
  // {
  //   key: HeaderItemKey.DIMENSION_PREVIOUS_VERSION,
  //   label: 'Dimension (Previous Version)',
  //   icons: DimensionsIcon,
  //   link: '/d/dimensions-legacy',
  // },
  {
    key: HeaderItemKey.MEMBER_MANAGEMENT,
    label: 'Member Management',
    icons: profileIcon,
    link: '/members',
    visible: (config) => config.ENABLE_HRDB_MEMBER_MANAGEMENT === 'true',
  },
  {
    key: HeaderItemKey.SIGNOUT,
    label: 'Sign out',
    icons: LogoutIcon,
  },
];
